import { render, staticRenderFns } from "./CajaRetiroEfectivo.vue?vue&type=template&id=861c5bae&"
import script from "./CajaRetiroEfectivo.vue?vue&type=script&lang=js&"
export * from "./CajaRetiroEfectivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports